export default {"src":"/_next/static/media/sandwatch.e93d5955.svg","height":20,"width":14,"blurWidth":0,"blurHeight":0};